import type { HabitWithLog } from '../interfaces'

export interface HabitToggleStyleParams {
  isCompleted: boolean
  isSkipped: boolean
  isReadOnlyDate?: boolean
  isFutureDate?: boolean
}

export function getHabitToggleStyle({
  isCompleted,
  isSkipped,
  isReadOnlyDate,
  isFutureDate,
}: HabitToggleStyleParams): string {
  const isLocked = isReadOnlyDate ?? isFutureDate ?? false
  if (isLocked) {
    return 'border-gray-200 bg-gray-50'
  }
  if (isCompleted) {
    return 'border-indigo-500 bg-indigo-500 text-white'
  }
  if (isSkipped) {
    return 'border-amber-300 bg-amber-50 text-amber-500'
  }
  return 'border-gray-300 bg-white'
}

export interface HabitNameStyleOptions {
  isSubHabit?: boolean
}

export function getHabitNameStyle(
  habit: Pick<HabitWithLog, 'isCompletedThisPeriod' | 'isSkippedThisPeriod'>,
  isReadOnlyDate: boolean,
  options?: HabitNameStyleOptions,
): string {
  const isSubHabit = options?.isSubHabit ?? false

  if (habit.isCompletedThisPeriod && !isReadOnlyDate) {
    return isSubHabit
      ? 'text-gray-500 line-through'
      : 'text-gray-900 line-through'
  }

  if (habit.isSkippedThisPeriod && !isReadOnlyDate) {
    return 'text-gray-400 italic'
  }

  return isSubHabit ? 'text-gray-700' : 'text-gray-900'
}
